var Marionette = require('backbone.marionette');
var Organization = require('../../models/organization');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var CommonUtils = require('../../utils/common-utils.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var OrganizationForm = Marionette.View.extend({
    tagName: 'form',
    template: require('../../templates/organizations/organization-form.html'),
    model: new Organization(),

    modelEvents: {
        change: 'render'
    },

    regions: {
        stateSelect: '#state-select'
    },

    ui: {
        name: '#id-name',
        addressField: '.address-field',
        zip: '#zip',
        address: '#address',
        town: '#town',

        created: '#creation-date',
        npi: '#id-npi',
        reviewPeriodDays: '#review-period-days',
        reviewPeriodHours: '#review-period-hours',

        progress: '#progress',
        reRequest: '#re-request',
        fillForm: '#fill-form'
    },

    events: {
        'blur @ui.name': 'validate',
        'keyup @ui.name': 'validate',

        'keyup @ui.npi': 'onNpiChange',
        'change @ui.npi': 'onNpiChange',
        'keypress @ui.npi': 'onNpiKeyPress',

        'keyup @ui.addressField': 'onAddressChange',
        'change @ui.addressField': 'onAddressChange',

        'click @ui.reRequest': 'onReRequest',
        'click @ui.fillForm': 'onFormFill'
    },

    defaultValidatingResults: {
        "id-name": false,
        "npi": false
    },

    validatingResults: undefined,

    tempNpi: '',
    npiOrganizationData: undefined,

    templateContext: function () {
        var that = this;
        var created = that.model.get('object').created;
        return {
            created: (created == '' || created == null || created == 0 ? ''
                : that.utils.longToDateTimeFormatted(Number(created), 'MM/DD/YYYY')),
            days: that.utils.getDaysValues(),
            hours: that.utils.getHoursValues(),
            isEditMode: that.isEditMode
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'fillModel', 'clearModel', 'validate');
        this.model.on('change', this.render, this);

        this.isEditMode = options.isEditMode;

        this.utils = new CommonUtils();

        this.validatingResults = _.clone(this.defaultValidatingResults);
        if (this.model.get('name'))
            this.validatingResults["id-name"] = true;
        if (this.model.get('object').npi && this.utils.isValidNPI(this.model.get('object').npi) || _.isEmpty(this.model.get('object').npi))
            this.validatingResults["npi"] = true;

        this.addressesAndContactsFromNpi = {};
        this.isAddressFieldFilledManually = true;

        this.address = {
            uuid: this.utils.generatedUUID(),
            country: '',
            state: '',
            zip: '',
            town: '',
            address: '',
            usage: 'WP',
            source: 'MANUAL'
        };
    },

    onRender: function () {
        var that = this;

        that.ui.created.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        that.ui.reviewPeriodDays.selectize({
            allowEmptyOption: false,
            placeholder: 'Days',
            inputClass: 'form-control selectize-input'
        });

        that.ui.reviewPeriodHours.selectize({
            allowEmptyOption: false,
            placeholder: 'Hours',
            inputClass: 'form-control selectize-input'
        });

        that.ui.progress.parent().hide();
        that.ui.reRequest.parent().hide();
        that.ui.fillForm.parent().hide();

        if (that.utils.isValidNPI(that.ui.npi.val())) {
            that.npiRequest(that.ui.npi.val());
        } else {
            that.ui.fillForm.prop('disabled', true);
        }

        if (!this.isEditMode)
            this.showStateSelect();

        that.checkSaveBtn();
    },

    showStateSelect: function () {
        var that = this;

        that.showChildView('stateSelect', new RemoteSuggesterView({
            tag: 'state',
            inputId: 'state',
            maxNumberOfElements: 20,
            url: '/api/reference/states/~~~',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element;
            },
            classes: ["form-control", "address-field"],
            placeholder: "Select state",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return arr[index] || null;
            }
        }));
    },

    fillModel: function () {

        var that = this;
        var object = this.model.get('object');
        var contacts = object.contacts || [];
        var addresses = object.addresses || [];
        var representatives = object.representatives || [];
        var ccrPermissions = object.ccrPermissions;
        var ccdPermissions = object.ccdPermissions;

        if (that.addressesAndContactsFromNpi.addresses && !_.isEmpty(that.addressesAndContactsFromNpi.addresses)) {
            addresses = addresses.filter(function (address) {
                return address.source != 'NPI';
            });
            that.addressesAndContactsFromNpi.addresses.forEach(function (address) {
                addresses.push(address);
            });
        }
        if (that.addressesAndContactsFromNpi.contacts && !_.isEmpty(that.addressesAndContactsFromNpi.contacts)) {
            var preferredContacts = contacts.filter(function (contact) {
                return contact.preferred === true;
            });
            contacts = contacts.filter(function (contact) {
                return contact.source != 'NPI';
            });
            that.addressesAndContactsFromNpi.contacts.forEach(function (contact) {
                if (contact.type === "FAX" && (preferredContacts.length == 0 || preferredContacts.filter(function (ctct) {
                        return ctct.data === contact.data && contact.type === "FAX" && ctct.type === "FAX";
                    }).length > 0)) {
                    contact.preferred = true;
                } else {
                    contact.preferred = false;
                }
                contacts.push(contact);
            });
        }

        if (!that.isEditMode && that.isAddressFieldFilledManually) {
            that.address.source = "MANUAL";
            addresses.push(that.address);
        }

        that.model.set({
            name: that.ui.name.val(),
            object: that.utils.mergeObjectsLeft(object, {
                created: that.utils.dateToLong(that.ui.created.val()),
                npi: that.ui.npi.val(),
                contacts: contacts,
                addresses: addresses,
                representatives: representatives,
                ccrPermissions: ccrPermissions,
                ccdPermissions: ccdPermissions,
                defaultReviewPeriod: {
                    days: that.ui.reviewPeriodDays.val(),
                    hours: that.ui.reviewPeriodHours.val()
                }
            })
        }, {validate: true});

        return this.model;
    },

    clearModel: function () {
        this.model.set(this.model.defaults);
        return this.model;
    },

    validatingFunctions: {
        "id-name": function (value) {
            if (value.length == 0)
                return "Name should not be empty";
            else return "";
        }
    },

    validate: function (event) {
        var jQelement = $(event.target);
        this.validateBy(jQelement);
    },

    validateBy: function (jQelement) {
        var value = jQelement.val();
        var id = jQelement.attr('id');

        var checkResult = this.validatingFunctions[id](value);

        if (checkResult.length > 0) {
            this.addErrorClass(jQelement);
            this.addTooltip(jQelement, checkResult);
            this.updateValidatingResults(id, false);
        }
        else {
            this.removeErrorClass(jQelement);
            this.removeTooltip(jQelement);
            this.updateValidatingResults(id, true);
        }
    },

    updateValidatingResults: function (name, value) {
        this.validatingResults[name] = value;
        this.checkSaveBtn();
    },

    addTooltip: function (jQelement, text) {
        jQelement.tooltip({title: text});
    },

    removeTooltip: function (jQelement) {
        jQelement.tooltip("destroy");
    }
    ,

    addErrorClass: function (jQelement) {
        jQelement.parent().parent().addClass('has-error has-feedback');
    },

    removeErrorClass: function (jQelement) {
        jQelement.parent().parent().removeClass('has-error has-feedback');
    },

    checkSaveBtn: function () {
        if (this.validatingResults["id-name"] && this.validatingResults["npi"]) {
            this.triggerMethod('organization:save:valid', {result: true});
        } else {
            this.triggerMethod('organization:save:valid', {result: false});
        }
    },

    onNpiChange: function (event) {
        var that = this;
        var value = event.target.value;
        var tempIdOld = that.tempNpi;
        that.tempNpi = value;

        if (that.utils.isValidNPI(value) && tempIdOld != value) {
            that.ui.fillForm.prop('disabled', false);
            window.setTimeout(function () {
                that.npiRequest(value);
            }, 0);
            return;
        } else {
            that.destroyFilledAddressesAndContacts();
        }

        if (_.isEmpty(value)) {
            that.ui.npi.tooltip("destroy");
            that.ui.npi.parent().removeClass('has-error has-feedback');
            that.validatingResults["npi"] = true;
            that.checkSaveBtn();
            that.ui.fillForm.prop('disabled', true);
            return;
        }

        if (!that.utils.isValidNPI(value)) {
            that.ui.npi.tooltip({title: 'Invalid NPI'});
            that.ui.npi.parent().addClass('has-error has-feedback');
            that.validatingResults["npi"] = false;
            that.checkSaveBtn();
            that.ui.fillForm.prop('disabled', true);
            return;
        }
    },

    onNpiKeyPress: function (event) {
        event = event || window.event;  // IE support
        var ctrlDown = event.ctrlKey || event.metaKey;

        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
            ctrlDown || event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 10;
    },

    onReRequest: function () {
        this.npiRequest(this.ui.npi.val());
    },

    npiRequest: function (value) {
        var that = this;
        that.onNpiRequestStart();
        $.ajax({
            type: "GET",
            url: '/api/npi?type=NPI_2&number=' + value,
            statusCode: {
                200: function (response) {
                    if (response.length == 0) {
                        that.onNpiRequestFailure();
                        that.npiOrganizationData = undefined;
                    }
                    else {
                        that.onNpiRequestSuccess();
                        that.npiOrganizationData = that.utils.organizationDataFromNpiData(response[0]);
                        that.npiData = response[0];
                    }
                }
            },
            error: function (e) {
                that.onNpiRequestEnd();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    onNpiRequestStart: function () {
        this.ui.npi.parent().removeClass('col-xs-10 col-md-10');
        this.ui.npi.parent().addClass('col-xs-7 col-md-7');
        this.ui.progress.parent().show();
        this.ui.reRequest.parent().hide();
        this.ui.fillForm.parent().hide();
        this.ui.fillForm.prop('disabled', true);
        this.ui.npi.tooltip("destroy");
        this.ui.npi.attr('disabled', true);
    },

    onNpiRequestSuccess: function () {
        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().hide();
        this.ui.fillForm.parent().show();
        this.ui.fillForm.prop('disabled', false);
        this.ui.npi.tooltip({title: 'Organization with NPI found'});
        this.ui.npi.parent().removeClass('has-error has-feedback');
        this.ui.npi.removeAttr('disabled');
        this.validatingResults["npi"] = true;
        this.checkSaveBtn();
    },

    onNpiRequestFailure: function () {
        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().show();
        this.ui.fillForm.parent().hide();
        this.ui.fillForm.prop('disabled', true);
        this.ui.npi.tooltip({title: 'Organization with NPI found'});
        this.ui.npi.parent().addClass('has-error has-feedback');
        this.ui.npi.removeAttr('disabled');
        this.validatingResults["npi"] = false;
        this.checkSaveBtn();
    },

    onNpiRequestEnd: function () {
        this.ui.npi.parent().removeClass('col-xs-7 col-md-7');
        this.ui.npi.parent().addClass('col-xs-10 col-md-10');
        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().hide();
        this.ui.fillForm.prop('disabled', true);
        this.ui.npi.tooltip("destroy");
        this.ui.npi.removeAttr('disabled');
        this.validatingResults["npi"] = false;
        this.checkSaveBtn();
    },

    onFormFill: function () {
        this.ui.name.val(this.npiOrganizationData["name"]);
        this.validateBy(this.ui.name);
        if (this.npiOrganizationData["createdDT"]) {
            this.ui.created.datepicker('update', this.utils.longToDateTimeFormatted(this.npiOrganizationData["createdDT"], 'MM/DD/YYYY'));
        }
        if (!this.isEditMode) {
            var addressObject = this.npiOrganizationData['address'];
            this.ui.zip.val(addressObject.zip);
            this.ui.address.val(addressObject.address);
            this.ui.town.val(addressObject.town);
            $('#state').val(addressObject.state);
            this.address.zip = addressObject.zip;
            this.address.address = addressObject.address;
            this.address.town = addressObject.town;
            this.address.state = addressObject.state;

            this.isAddressFieldFilledManually = false;
        }

        this.fillAddressesAndContactsFromNpi();
        notificationsChannel.request('show:notification', {
            message: 'Profile is filled with data from NPI registry',
            code: 200
        });
    },

    destroyFilledAddressesAndContacts: function () {
        this.addressesAndContactsFromNpi = {};
    },

    fillAddressesAndContactsFromNpi: function () {
        this.addressesAndContactsFromNpi = this.utils.addressesAndContactsFromNpiData(this.npiData);
    },

    onAddressChange: function (event) {
        this.address[event.target.id] = event.target.value;
        this.isAddressFieldFilledManually = true;
    }

});

module.exports = OrganizationForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/organization-form.js
// module id = 216
// module chunks = 0